export const iconFontAwesomeHolidaysHeart = (
	<i className="fa-solid fa-heart"></i>
);
